module.exports = __webpack_public_path__ + "4d74c4e2ed61b4b81d0ebbb90c34a694.png";